@if (references.length > 0) {
  <div class="references-container">
    <div class="references-header">
      <mat-icon class="references-icon">format_quote</mat-icon>
      <h3>References</h3>
    </div>
    @for (ref of references; track $index) {
      <div
        class="references-item"
        [class.references-item--external-blocks]="showReferenceInReferenceRows(ref)"
      >
        @if (showSourceReference(ref)) {
          <div class="references-item__legacy">
            @for (item of ref.children; track $index) {
              <app-new-source-preview-button
                [adaptedReference]="item"
                (buttonClicked)="sourceSelected.emit($event)"
              ></app-new-source-preview-button>
            }
            <span class="references-item__single-label">{{ panelLabel(ref) }}</span>
          </div>
        }
        @if (showReferenceInReferenceRows(ref)) {
          <div class="references-item__external" role="group" [attr.aria-label]="'References for ' + ref.originalSource.name">
            @for (row of rowsForRef(ref); track trackRefRow($index, row)) {
              @switch (row.kind) {
                @case ('external') {
                  <div class="ref-external-block">
                    <ul class="ref-external-block__list">
                      @for (ext of row.lines; track $index; let extIndex = $index) {
                        <li>
                          <app-new-source-preview-button
                            [adaptedReference]="row.child"
                            [displayLabelOverride]="externalRowLabel(row.child, extIndex)"
                            [externalReferenceIndex]="extIndex"
                            (buttonClicked)="sourceSelected.emit($event)"
                          ></app-new-source-preview-button>
                          @if (externalLineUrl(ext); as url) {
                            <a [href]="url" target="_blank" rel="noopener noreferrer">
                              {{ formatExtLine(ext) }}
                            </a>
                          } @else {
                            {{ formatExtLine(ext) }}
                          }
                        </li>
                      }
                    </ul>
                  </div>
                }
                @case ('inlineGroup') {
                  <div class="ref-inline-row">
                    @for (child of row.children; track child.listPositionIndex ?? $index) {
                      <app-new-source-preview-button
                        [adaptedReference]="child"
                        (buttonClicked)="sourceSelected.emit($event)"
                      ></app-new-source-preview-button>
                    }
                    <span class="ref-inline-row__cite">{{ row.sharedLabel }}</span>
                  </div>
                }
              }
            }
          </div>
        }
      </div>
    }
  </div>
}
